const pkConfig = {
  // 正在pk中的信息
  pkingInfo: `/authApi/show/v1/pk/pkingInfo`,
  // pk贡献榜单
  contributionRank: `/authApi/show/v1/pk/contributionRank`,
  // 获取pk结果
  pkResult: `/authApi/show/v1/pk/pkResult`,
  // 检查是否第一次进入pk （96秀的 盒子先不用
  checkDayEnterPkLive: '/authApi/show/v1/pk/checkDayEnterPkLive'
};

export default pkConfig;
